import React from "react";

// Local Imports
import jsReactTodo from "../../images/web_development/JavaScriptReactTodo.png";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function WD_Project_5() {
  // React-JavaScript Todo App
  const openPopupBoxJSTodoApp = () => {
    const content = (
      <>
        <div className="image-center">
          <img className="portfolio-image-popupbox" src={jsReactTodo} alt="" />
        </div>
        <p>
          An simple JavaScript-React Todo app called Checkd designed to showcase
          my coding and design abilities
        </p>
        <a
          className="hyper-link"
          onClick={() =>
            window.open("https://github.com/jenkrame21/js_todo_app/", "_blank")
          }
        >
          GitHub Repo
        </a>
        &nbsp;
        <a
          className="hyper-link"
          onClick={() =>
            window.open("https://js-todo-app-navy.vercel.app/", "_blank")
          }
        >
          Deployment
        </a>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Checkd | JavaScript-React Todo Application",
        },
      },
    });
  };

  const popupboxConfigJSTodoApp = {
    titleBar: {
      enable: true,
      text: "Checkd | JavaScript-React Todo Application",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div className="portfolio-image-box" onClick={openPopupBoxJSTodoApp}>
        <img
          className="portfolio-image"
          src={jsReactTodo}
          alt="Screenshot of JavaScript-React Todo Application"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigJSTodoApp} />
    </>
  );
}

export default WD_Project_5;
